(function ($) {
    $(document).ready(function () {
        $('#resort-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            asNavFor: '#resort-slider-nav',
            dots: false,
            arrows: false,
            infinite: true,
            speed: 700,
            autoplaySpeed: 2000,
            adaptiveHeight: true,
            lazyLoad: 'ondemand' // Add lazy loading option
        });

        $('#resort-slider-nav').slick({
            slidesToShow: 8,
            slidesToScroll: 1,
            arrows: true,
            asNavFor: '#resort-slider',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            lazyLoad: 'ondemand' // Add lazy loading option
        });

        $("[id=accommodation-carousel]").slick({
            dots: false,
            infinite: true,
            speed: 1500,
            slidesToShow: 4,
            slidesToScroll: 3,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: false,
                        pauseOnHover: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });
        /*Slick equal height slides*/
        /* .on("setPosition", function () {
            resizeSlider();
        });
        $(window).on("resize", function (e) {
            resizeSlider();
        });
        var slickHeight = $("[id=accommodation-carousel]").outerHeight();
        var slideHeight = $("[id=accommodation-carousel]").find(".slick-slide").outerHeight();
        var imageHeight = $("[id=accommodation-carousel]").find(".slick-slide .feature-img").outerHeight()
        function resizeSlider() {
            $(".slick-track")
                .find(".slick-slide")
                .css("height", (slickHeight - imageHeight) + "px");
        };*/
        $(".selector select").each(function () {
            var obj = $(this);
            if (obj.parent().children(".custom-select").length < 1) {
                obj.after("<span class='custom-select'>" + obj.children("option:selected").html() + "</span>");

                if (obj.hasClass("white-bg")) {
                    obj.next("span.custom-select").addClass("white-bg");
                }
                if (obj.hasClass("w-full")) {
                    //obj.removeClass("full-width");
                    //obj.css("width", obj.parent().width() + "px");
                    //obj.next("span.custom-select").css("width", obj.parent().width() + "px");
                    obj.next("span.custom-select").addClass("w-full");
                }
            }
        });
        $("body").on("change", ".selector select", function () {
            if ($(this).next("span.custom-select").length > 0) {
                $(this).next("span.custom-select").text($(this).children("option:selected").text());
            }
        });

        $("body").on("keydown", ".selector select", function () {
            if ($(this).next("span.custom-select").length > 0) {
                $(this).next("span.custom-select").text($(this).children("option:selected").text());
            }
        });
    });//document ready
    /*$(document).ready(function () {
        // Function to fetch window width and update image sources
        function fetchAndUpdateImages() {
            var windowWidth = $(window).width();
            // Limit windowWidth to a maximum of 866px
            if (windowWidth > 866) {
                windowWidth = 866;
            }
            $('.tacrm-slide-image').each(function() {
                var imageUrl = $(this).data('image-url');
                $.ajax({
                    url: TACRM.ajax_url, // WordPress AJAX URL
                    type: 'POST',
                    data: {
                        action: 'fetch_image_url', // Action to handle the AJAX request in WordPress
                        width: windowWidth, // Pass the window width as data
                        image_url: imageUrl // Pass the image URL as data
                    },
                    success: function(response) {
                        // Update image source with the received URL
                        $(this).attr('src', response);
                    }.bind(this), // Bind the context of the success callback to the current image element
                    error: function(xhr, status, error) {
                        console.error('AJAX Error:', error);
                    }
                });
            });
        }
        // Check if any element with the class 'dynamic-image' exists
        if ($('.tacrm-slide-image').length > 0) {
            // Call fetchAndUpdateImages on window load and resize
            $(window).on('load resize', fetchAndUpdateImages);
        }
    });*/
    jQuery(window).on('load', function() {
        // Function to fetch window width and update image sources
        function fetchAndUpdateImages() {
            var windowWidth = jQuery(window).width();
            // Limit windowWidth to a maximum of 866px
            if (windowWidth > 866) {
                windowWidth = 866;
            }
            jQuery('.tacrm-slide-image').each(function() {
                var imageUrl = jQuery(this).data('image-url');
                jQuery.ajax({
                    url: TACRM.ajax_url, // WordPress AJAX URL
                    type: 'POST',
                    data: {
                        action: 'fetch_image_url', // Action to handle the AJAX request in WordPress
                        width: windowWidth, // Pass the window width as data
                        image_url: imageUrl // Pass the image URL as data
                    },
                    success: function(response) {
                        // Update image source with the received URL
                        jQuery(this).attr('src', response);
                    }.bind(this), // Bind the context of the success callback to the current image element
                    error: function(xhr, status, error) {
                        console.error('AJAX Error:', error);
                    }
                });
            });
        }

        // Check if any element with the class 'dynamic-image' exists
        if (jQuery('.tacrm-slide-image').length > 0) {
            // Call fetchAndUpdateImages
            fetchAndUpdateImages();
        }
    });

})(jQuery);

document.addEventListener("alpine:init", async () => {
    Alpine.data("tacrm_category_view_init", (categoryID, req_for) => ({
            isLoading: false,
            showContent: false,
            openTab: 'tab1',
            openextab: 'extab1',
            extabactive: 'bg-zinc-50',
            extabinactive: 'bg-zinc-200/90',
            postTemplate: 'gridView',
            activeClasses: 'bottom-arrow bg-sky-400 text-white hover:text-white',
            inactiveClasses: ' bg-zinc-100 hover:bg-sky-400 hover:text-white bg-zinc-200/50',
            currentPage: 'bg-amber-400 text-white',
            tacrm_pagination: 'bg-white',
            sortby: 'name',
            sortto: 'asc',
            activesort: 'active',
            response: '',
            page: 1,
            async sortorder(sortby = this.sortby) {
                this.isLoading = true;
                if (this.sortby == sortby) {
                    this.sortto = (this.sortto == 'asc') ? 'desc' : 'asc';
                } else {
                    this.sortby = sortby;
                    this.sortto = 'asc';
                }
                this.view_init(1, sortby, this.sortto);
            },
            async sorting_orderby() {
                var lis = document.querySelectorAll("#sortingorders li");
                if (lis.length > 0) {
                    lis.forEach((li_item) => {
                        li_item.classList.remove('arrowup');
                        li_item.classList.add('arrowdown');
                        if (li_item.classList.contains('active')) {
                            li_item.classList.remove('arrowdown');
                            li_item.classList.add('arrowup');
                        }
                        if (this.sortto == 'asc') {
                            this.$el.classList.remove('arrowdown');
                            this.$el.classList.add('arrowup');
                        } else {
                            this.$el.classList.remove('arrowup');
                            this.$el.classList.add('arrowdown');
                        }
                    });
                }
            },
            async load_view(e) {
                this.postTemplate = e.target.getAttribute('data-view') || e.target.parentElement.getAttribute('data-view');
                if (this.postTemplate === null) {
                    this.postTemplate = e.target.parentElement.parentElement.getAttribute('data-view');
                }
                this.view_init(1, this.sortby, this.sortto);
            },
            async pagination(page = this.page) {
                this.page = page;
                this.view_init(page, this.sortby, this.sortto);
                const section = document.getElementById('resorts-pane');
                window.scrollTo({top: section.offsetTop, behavior: 'smooth'});
            },
            async view_init(page = 1, orderby = 'name', orderto = 'asc') {
                this.isLoading = true;
                this.page = page;
                /**/
                await fetch(TACRM.ajax_url, {
                    method: "POST", // *GET, POST, PUT, DELETE, etc.
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                        'Cache-Control': 'no-cache'
                    },
                    body: "action=tacrm_category_resorts_view&viewtype=" + this.postTemplate + "&req_for=" + req_for + "&categoryID=" + categoryID + "&page=" + page + "&orderby=" + orderby + "&orderto=" + orderto,
                    //credentials: 'same-origin',
                })
                    .then((response) => {
                        response.json().then(data => {
                            // This is where you get your response back in "data" variable
                            this.response = data;
                        });
                    })
                    .catch(() => {
                        this.response = '<p>Ooops! Something went wrong!</p>';
                    })
                    .finally(() => {
                        // Fires when you have finally got the response.
                        this.isLoading = false;
                        this.sorting_orderby();
                        this.showContent = true;
                    })
            }
            /**/
        })
    ),
        Alpine.data("tacrm_search_box", () => ({
                child_list: [{value: "", name: "Select Location"}],
                setectedlocation: '',
                async triggerSelectChange() {
                    // Trigger change event using jQuery
                    jQuery('.selector select').change();
                },
                async search_init() {
                    var parts = window.location.search.substring(1).split("&");
                    var $_GET = {};
                    for (var i = 0; i < parts.length; i++) {
                        var temp = parts[i].split("=");
                        $_GET[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
                    }
                    if ($_GET['location'] != undefined) {
                        let category = $_GET['destination'];
                        const category_slug = category.split("|");
                        this.req_api(category_slug[0]);
                        this.setectedlocation = $_GET['location'];
                    }
                },
                async get_childs(e) {
                    let category = e.target.options[e.target.selectedIndex].value;
                    const category_slug = category.split("|");
                    this.req_api(category_slug[0]);
                },
                async req_api(category_slug) {
                    this.child_list = [{value: "", name: "Loading..."}];
                    setTimeout(() => this.triggerSelectChange(), 500);
                    await fetch(TACRM.ajax_url, {
                        method: "POST", // *GET, POST, PUT, DELETE, etc.
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                            'Cache-Control': 'no-cache'
                        },
                        body: "action=tacrm_search_categories&slug=" + category_slug,
                        //credentials: 'same-origin',
                    })
                        .then((response) => {
                            response.json().then(data => {
                                // This is where you get your response back in "data" variable
                                if (data.length > 0) {
                                    this.child_list = data;
                                } else {
                                    this.child_list = [{value: "0", name: "No Location Found"}];
                                }
                            });
                        })
                        .catch(() => {
                            this.response = '<p>Ooops! Something went wrong!</p>';
                        })
                        .finally(() => {
                            // Fires when you have finally got the response.
                            setTimeout(() => this.triggerSelectChange(), 1000);
                        })
                }
            })
        ),
        Alpine.data("load_accommodations", () => ({
                isLoading: false,
                showContent: false,
                response: '',
                is_clickevent_call : false,
                async initSlickSlider(elementID,unslick = false) {
                    if(unslick){
                        jQuery('#'+elementID).slick('unslick');
                    }
                    let element = jQuery("#" + elementID);
                    if (element.length > 0) {
                        element.slick({
                            dots: false,
                            infinite: true,
                            speed: 1500,
                            slidesToShow: 4,
                            slidesToScroll: 3,
                            autoplay: true,
                            autoplaySpeed: 2000,
                            pauseOnHover: true,
                            arrows: true,
                            responsive: [
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 2,
                                        infinite: true,
                                        dots: false,
                                        pauseOnHover: true,
                                    }
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 2
                                    }
                                },
                                {
                                    breakpoint: 480,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1
                                    }
                                }
                            ]
                        });
                    }
                },
                async refreshAllSlickSliders(elementid) {
                    setTimeout(() => {
                        this.initSlickSlider(elementid);
                    }, 2000);

                    if(!this.is_clickevent_call){
                        this.jqclicktabevent();
                    }
                },
            async jqclicktabevent(){
                this.is_clickevent_call = true;
                let vm = this;
                // Use .on() to bind the click event to the tab elements
                jQuery(document).on('click', '.fusion-tabs .tab-link', function() {
                    var tabPanelId = jQuery(this).attr('aria-controls');
                    // Find the accommodation-carousel elements within the corresponding tab panel
                    var accommodationCarousels = jQuery('#' + tabPanelId).find('.accommodation-carousel');
                    // Check if any accommodation-carousel element is found
                    if (accommodationCarousels.length > 0) {
                        // Loop through each accommodation-carousel element and log its ID
                        accommodationCarousels.each(function () {
                            var carouselId = jQuery(this).attr('id');
                            vm.initSlickSlider(carouselId,true);
                        });
                    }
                });
            },
                async init_accommodations(type, style, attr, security) {
                    this.isLoading = true;
                    this.showContent = true;

                    // alert(style)
                    await fetch(TACRM.ajax_url, {
                        method: "POST", // *GET, POST, PUT, DELETE, etc.
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                            'Cache-Control': 'no-cache'
                        },
                        body: "action=load_accommodation_shortcode&type=" + type + "&style=" + style + "&attr=" + JSON.stringify(attr) + "&security=" + security,
                        //credentials: 'same-origin',
                    })
                        .then((response) => {
                            response.json().then(data => {
                                // This is where you get your response back in "data" variable
                                if (data.length > 0) {
                                    this.response = data;
                                } else {
                                    this.response = [{value: "0", name: "No Location Found"}];
                                }
                            });
                        })
                        .catch(() => {
                            this.response = '<p>Ooops! Something went wrong!</p>';
                        })
                        .finally(() => {
                            // Fires when you have finally got the response.
                            this.isLoading = false;
                        })
                }
            })
        )
});